var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4d01e;\n      }\n\n      .cls-2 {\n        fill: #f7c887;\n      }\n\n      .cls-3 {\n        fill: #004281;\n      }\n\n      .cls-4 {\n        fill: #00adee;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #ff8c00;\n      }\n\n      .cls-7 {\n        fill: #bd9bb8;\n      }\n\n      .cls-8 {\n        fill: #0c64af;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.5,52c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Zm0-4c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.5,10c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Zm0-4c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.83,3.71c-.11-.06-.63-.35-.78-.42-.14-.08-.26-.2-.34-.34-.08-.14-.37-.67-.42-.78s-.17-.17-.29-.17-.23.07-.29.17-.34.63-.42.78c-.08.14-.2.26-.34.34-.14.08-.67.37-.78.42-.11.06-.17.17-.17.29s.06.23.17.29c.11.06.63.35.78.42.14.08.26.2.34.34.08.14.37.67.42.78s.17.17.29.17.23-.07.29-.17.34-.63.42-.78c.08-.14.2-.26.34-.34.14-.08.67-.37.78-.42.11-.06.17-.17.17-.29s-.06-.23-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10.83,39.71c-.11-.06-.63-.35-.78-.42-.14-.08-.26-.2-.34-.34-.08-.14-.37-.67-.42-.78s-.17-.17-.29-.17-.23.07-.29.17-.34.63-.42.78c-.08.14-.2.26-.34.34-.14.08-.67.37-.78.42-.11.06-.17.17-.17.29s.06.23.17.29c.11.06.63.35.78.42.14.08.26.2.34.34.08.14.37.67.42.78s.17.17.29.17.23-.07.29-.17.34-.63.42-.78c.08-.14.2-.26.34-.34.14-.08.67-.37.78-.42.11-.06.17-.17.17-.29s-.06-.23-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m49.87,39.28c-.08-.04-.47-.26-.58-.32s-.2-.15-.25-.25-.27-.5-.32-.58-.13-.13-.22-.13-.17.05-.22.13-.26.47-.32.58-.15.2-.25.25-.5.28-.58.32-.13.13-.13.22.05.17.13.22.47.26.58.32.2.15.25.25.27.5.32.58.13.13.22.13.17-.05.22-.13.26-.47.32-.58.15-.2.25-.25.5-.28.58-.32.13-.13.13-.22-.05-.17-.13-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.87,6.28c-.08-.04-.47-.26-.58-.32s-.2-.15-.25-.25-.27-.5-.32-.58-.13-.13-.22-.13-.17.05-.22.13-.26.47-.32.58-.15.2-.25.25-.5.28-.58.32-.13.13-.13.22.05.17.13.22.47.26.58.32.2.15.25.25.27.5.32.58.13.13.22.13.17-.05.22-.13.26-.47.32-.58.15-.2.25-.25.5-.28.58-.32.13-.13.13-.22-.05-.17-.13-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m61.87,16.28c-.08-.04-.47-.26-.58-.32s-.2-.15-.25-.25-.27-.5-.32-.58-.13-.13-.22-.13-.17.05-.22.13-.26.47-.32.58-.15.2-.25.25-.5.28-.58.32-.13.13-.13.22.05.17.13.22.47.26.58.32.2.15.25.25.27.5.32.58.13.13.22.13.17-.05.22-.13.26-.47.32-.58.15-.2.25-.25.5-.28.58-.32.13-.13.13-.22-.05-.17-.13-.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.75,
    cy: 0.75,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 54.75,
    cy: 25.75,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.75,
    cy: 46.75,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 0.5,
    cy: 35.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 10.5,
    cy: 11.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 63.5,
    cy: 21.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 54.5,
    cy: 35.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 47.5,
    cy: 52.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 63,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24,32c-6.28,0-13-6.83-13-17,0-.55.45-1,1-1h12c.55,0,1,.45,1,1v16c0,.55-.45,1-1,1ZM13.03,16c.39,7.75,5.26,13.23,9.97,13.93v-13.93h-9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40,32c-.55,0-1-.45-1-1V15c0-.55.45-1,1-1h12c.55,0,1,.45,1,1,0,10.17-6.72,17-13,17Zm1-16v13.93c4.72-.69,9.59-6.17,9.97-13.93h-9.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20,
    y: 51,
    width: 24,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 41,
    y: 51,
    width: 3,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 20,
    y: 51,
    width: 3,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44,60h-24c-.55,0-1-.45-1-1v-8c0-.55.45-1,1-1h24c.55,0,1,.45,1,1v8c0,.55-.45,1-1,1Zm-23-2h22v-6h-22v6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18,
    y: 59,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 43,
    y: 59,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18,
    y: 59,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46,64h-28c-.55,0-1-.45-1-1v-4c0-.55.45-1,1-1h28c.55,0,1,.45,1,1v4c0,.55-.45,1-1,1Zm-27-2h26v-2h-26v2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,39c0,2.5-1.83,7.33-6,8h16c-4.17-.67-6-5.5-6-8h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m40,47h-5.57c-1.41-1.88-1.79-5.96-1.93-8h1.5c0,2.5,1.83,7.33,6,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24,47h5.57c1.41-1.88,1.79-5.96,1.93-8h-1.5c0,2.5-1.83,7.33-6,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40,48h-16c-.52,0-.96-.4-1-.92-.04-.52.32-.98.84-1.07,3.6-.58,5.16-4.92,5.16-7.01,0-.55.45-1,1-1h4c.55,0,1,.45,1,1,0,2.09,1.56,6.44,5.16,7.01.51.08.88.55.84,1.07-.04.52-.48.92-1,.92Zm-11.99-2h7.99c-1.74-1.72-2.66-4.16-2.92-6h-2.15c-.26,1.84-1.18,4.28-2.92,6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23,
    y: 47,
    width: 18,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 38,
    y: 47,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 23,
    y: 47,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41,52h-18c-.55,0-1-.45-1-1v-4c0-.55.45-1,1-1h18c.55,0,1,.45,1,1v4c0,.55-.45,1-1,1Zm-17-2h16v-2h-16v2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21,17v12c0,5.52,4.48,10,10,10h2c5.52,0,10-4.48,10-10v-12h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m40,17v12c0,5.35-4.21,9.71-9.5,9.97.17,0,.33.03.5.03h2c5.52,0,10-4.48,10-10v-12h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24,29v-12h-3v12c0,5.52,4.48,10,10,10h2c.17,0,.33-.02.5-.03-5.29-.26-9.5-4.62-9.5-9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24.62,37.7c-.22,0-.45-.08-.64-.23-.27-.22-.53-.46-.78-.71-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0c.2.2.42.4.64.58.43.35.49.98.13,1.41-.2.24-.48.36-.77.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m33,40h-2c-1.51,0-2.97-.3-4.34-.89-.51-.22-.74-.81-.52-1.31.22-.51.81-.74,1.31-.52,1.12.48,2.32.73,3.56.73h2c4.96,0,9-4.04,9-9v-11h-20v11c0,1.53.39,3.05,1.13,4.38.27.48.1,1.09-.39,1.36-.48.27-1.09.1-1.36-.39-.91-1.63-1.39-3.48-1.39-5.35v-12c0-.55.45-1,1-1h22c.55,0,1,.45,1,1v12c0,6.07-4.93,11-11,11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 11,
    width: 24,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 41,
    y: 11,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 20,
    y: 11,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44,18h-24c-.55,0-1-.45-1-1v-6c0-.55.45-1,1-1h18c.55,0,1,.45,1,1s-.45,1-1,1h-17v4h22v-4h-2c-.55,0-1-.45-1-1s.45-1,1-1h3c.55,0,1,.45,1,1v6c0,.55-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m49,64H14c-.55,0-1-.45-1-1s.45-1,1-1h35c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m53,64h-1c-.55,0-1-.45-1-1s.45-1,1-1h1c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.ead72fcd6ba65dc493424345377ba23e.svg";
export { ForwardRef as ReactComponent };